import { render, staticRenderFns } from "./PaymentPos.vue?vue&type=template&id=36a09e1e&"
import script from "./PaymentPos.vue?vue&type=script&lang=js&"
export * from "./PaymentPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports